module.exports = __webpack_public_path__ + "img/han_site2_12f.bcdac1ae.png";